// components/Filters/FilterField.jsx
import React from 'react';
import { Col, Form, theme } from 'antd';

const SHADOW_OFFSET = 1 // px

export const FilterField = ({
  name,
  col,
  children,
  modifiedFilters,
  ...FormItemProps
}) => {
  const { token: themeToken } = theme.useToken();

  const isModified = modifiedFilters
    ? Array.isArray(name)
      ? name.some((field) => modifiedFilters.has(field))
      : modifiedFilters.has(name)
    : false;

  // Se aplica sombra solo a los filtros modificados
  const shadow = `drop-shadow(0px 0px ${SHADOW_OFFSET}px ${themeToken.colorPrimary}) `;
  const wrapperColStyle = {
    filter: isModified ? shadow.repeat(2).trim() : 'none',
    transition: 'filter 0.5s ease',
  };

  const formItem = (
      <Form.Item
        name={name}
        layout='vertical'
        {...FormItemProps}
        style={{ marginBottom: 0 }}
        wrapperCol={{ style: wrapperColStyle }}
      >
        {children}
      </Form.Item>
  )

  return col ? <Col {...col}>{formItem}</Col> : formItem
};